import React from 'react';

const Card = (props) => {
    const {img,tite,description,price} =props.user;
    return (
        <div class="col-md-4">
    <div class="card h-100 m-2 p-2">
      <img src={img} class="card-img-top img-fluid" alt="..."/>
      <div class="card-body">
        <h5 class="card-title">{tite}</h5>
        <p class="card-text">{description}</p>
        <p class="card-text">Price:{price}$</p>
        <button className="btn btn-dark">Purchase</button>
      </div>
    </div>
  </div>
    );
};

export default Card;